/**
 * Feed item model
 */
export class FeedItem {
  /**
   * @constructor
   */
  constructor(public month: number, public year: number, public items: any[]) {}
}
